const i18n = require('swa-locale/i18n');

const CorporateLoginHeaderData = {
    traveler: {
        title: i18n('TITLE__CORPORATE_LOGIN_TRAVELER_HOME_PAGE'),
        description: i18n('TEXT__CORPORATE_LOGIN_DESCRIPTION_TRAVELER_HOME_PAGE')
    },
    travelManager: {
        title: i18n('TITLE__CORPORATE_LOGIN_TRAVEL_MANAGER_HOME_PAGE'),
        description: i18n('TEXT__CORPORATE_LOGIN_DESCRIPTION_TRAVEL_MANAGER_HOME_PAGE')
    }
};

module.exports = CorporateLoginHeaderData;
